import * as React from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { CodetableItemProps } from 'app/area/codetable/list/list-items/types';
import { CodeListMeatballMenu } from 'app/area/codetable/list/shared/meatball-menu';
import { UomCodetableItemContent } from 'app/area/codetable/list/list-renderer/screens/uom/uom-codetable-item-content';
import { CodetableItemRow } from 'app/area/codetable/list/list-items/common/codetable-item-row';
import styles from './uom-codetable-item.scss';

export class UomCodetableItem extends React.PureComponent<CodetableItemProps> {

  private onExpand = () => {
    const { codeItem, expandCodeItem } = this.props;
    expandCodeItem(codeItem.id);
  };

  public render() {

    const { isZebra, refetching, open, isHierarchyMode, hierarchyMetadata, breadcrumbs,
      codeItem, translation, deletingCodeItem, treeDepthLevel } = this.props;

    const shouldShowZebra = !(deletingCodeItem || codeItem.deletingCodeItem) && isZebra;

    const codeItemHierarchyMetadata = hierarchyMetadata.find(metadata => metadata.depthLevel === treeDepthLevel);

    const hasChildren = !!codeItemHierarchyMetadata ? codeItemHierarchyMetadata?.hasChildren : undefined;

    return <CodetableItemRow
      isZebra={shouldShowZebra}
      treeDepthLevel={treeDepthLevel}>
      {
        isHierarchyMode
          ? <div className={styles.expanderButtonContainer}>
            <button type="button" className={`${isZebra ? styles.zebra : ''} ${styles.expanderButton} ${open ? styles.open : ''} ${!hasChildren ? styles.hidden : ''} `}
              onClick={this.onExpand}>
              <FiChevronDown />
            </button>
          </div>
          : null
      }
      <UomCodetableItemContent
        breadcrumbs={breadcrumbs}
        codeItem={codeItem}
        isHierarchyMode={isHierarchyMode}
        refetching={refetching}
        deletingCodeItem={deletingCodeItem}
        treeDepthLevel={treeDepthLevel}
        hierarchyMetadata={hierarchyMetadata}
        translation={translation} />
      {!deletingCodeItem && <CodeListMeatballMenu {...this.props} />}
    </CodetableItemRow>;
  }
}
